import React from 'react'

import { withRouter } from 'react-router-dom'

import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import ReactToPrint from "react-to-print";
import { Button } from 'primereact/button'
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

import { AuthContext } from '../../main/ProvedorAutenticacao'

import '../financeiro/financeiro.css'
import './relatorioProcesso.css'

import imagemRelatorio from '../../pages/seguranca/img/ilaw-logo.png'

import RelatorioAtividadeService from '../../app/service/RelatorioAtividadeService'

class ComponentToPrintRelatorioAtividade extends React.Component {
  constructor(props) {
    super(props); 

    this.state = {
      nomeUsuario: '',
      dataImpressao: '',
      horaImpressao: '',
      filtro: null,
      quantidade: '',
    };
  }

  render() {
    return (
      <div>
        <br></br>
        <div style={{margin: '38px'}}>
            <div>
              <img src={imagemRelatorio} width="200" height="140"/>
            </div>
            <span className="relatorio">Relatório de Processos</span>
            <div>
              Impresso por: {this.props.nomeUsuario} &nbsp; 
              em: {this.state.dataImpressao}&nbsp;
              {this.state.horaImpressao}
            </div>
            <div>
              <span className="filtro">Filtros:&nbsp;{this.props.filtro}</span>
            </div>
            <div>
              Quantidade de Registros:&nbsp;{this.props.quantidade}
            </div>
            
            <hr></hr>
        </div>
        
        <div style={{margin: '46px'}}>
          <DataTable value={this.props.dados}  alwaysShowPaginator responsiveLayout="scroll" id="idRelatorio"
                              paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                              currentPageReportTemplate="Exibindo {first} para {last} de {totalRecords}" emptyMessage=" "
                              paginatorRight selectionMode="multiple">

              <Column field="titulo" header="Atividade"></Column>
              <Column field="tipoAtividade" header="Tipo"></Column>
              <Column field="descricao" header="Descrição"></Column>
              <Column field="dataLimite" header="Dt. Limite"></Column>
              <Column field="dataFatal" header="Prazo Fatal"></Column>
              <Column field="responsavel" header="Responsável"></Column>
              <Column field="subGrupo" header="Sub-Grupo de Trabalho"></Column>
              <Column field="grupo" header="Grupo de Trabalho"></Column>
              <Column field="numerocnj" header="CNJ"></Column>
              <Column field="numeroProcesso" header="N. Processo"></Column>
              <Column field="numeroPasta" header="Pasta"></Column>
              <Column field="autor" header="Autor"></Column>
              <Column field="reu" header="Réu"></Column>
          </DataTable>
        </div>
      </div>
    );
  }
}

class RelatorioAtividadeResult extends React.Component {
  constructor(props) {
    super(props)

    this.relatorioAtividadeService = new RelatorioAtividadeService();

    this.state = {
      relatorioResult: [],
      quantidade: '',
      openSpinner: false,
    }
  }

  consultarRelatorio = async (params) => {
    const filtro = {
      empresa: params.empresa,
      usuario: params.usuario,
      dtLimiteInicial: params.dataLimiteInicial,
      dtLimiteFinal: params.dataLimiteFinal,
      dtConcluidoInicial: params.dataConcluidoInicial,
      dtConcluidoFinal: params.dataConcluidoFinal,
      dtCriacaoInicial: params.dataCadastroInicial,
      dtCriacaoFinal: params.dataCadastroFinal,
      dtFatalInicial: params.dataFatalInicial,
      dtFatalFinal: params.dataFatalFinal,
      responsavel: params.responsavel,
      interessado: params.interessado,
      grupoTrabalho: params.grupoTrabalho,
      status: params.status,
      tipoAtividade: params.tipoAtividade,
      classificacao: params.classificacao,
      ordenacao: params.ordenacao
    }

    await this.relatorioAtividadeService.relatorioAtividade(filtro)
      .then(response => {
        this.setState({relatorioResult: response.data});
        this.setState({quantidade: response.data.length});
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Relatórios de Atividades', detail:`${this.state.detail}`, life: 4000});
      })
  }

  async componentDidMount() {
    const usuarioLogado = this.context.usuarioAutenticado;
    this.setState({nomeUsuario: usuarioLogado.nome});
    const params = this.props.match.params;
    this.setState({openSpinner: true});
    await this.consultarRelatorio(params);
    this.setState({openSpinner: false});
  }

  render() {
    return (
      <div className="content-wrapper">
        <section className="content-header">
          <div className="row">
            <div className="col-md-12">
              <div className="formGroup">
              <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={this.state.openSpinner}>
                <CircularProgress color="primary" style={{width: '130px', height: '130px'}}/>
              </Backdrop>
                <ReactToPrint
                  trigger={() => <a className="cursor" >Imprimir</a>}
                  content={() => this.componentRef}>
                </ReactToPrint>
                <ComponentToPrintRelatorioAtividade dados={this.state.relatorioResult}
                                                    ref={el => (this.componentRef = el)} />
              </div>
            </div>
          </div> 
        </section>
      </div>
    );
  }
}

RelatorioAtividadeResult.contextType = AuthContext;
export default withRouter(RelatorioAtividadeResult)